module.exports = __webpack_public_path__ + "static/media/Montserrat-UltraLight.816e4ead.otf";